import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Outlet } from "react-router-dom"
import axios from "../api/axios";
import Header from "./Header";
import { ENDPOINT_ACCOUNT_REFRESH_TOKEN } from "../Config";
import { EventProvider } from "../context/EventProvider";

const Layout = () => {
    const RETRY_AFTER_SECONDS = 5;
    const [isLoading, setIsLoading] = useState(true);
    const [isOffline, setIsOffline] = useState(false);
    const [retryAfter, setRetryAfter] = useState(RETRY_AFTER_SECONDS);

    useEffect(() => {
        let retryInterval = null;
        const ping = async () => {
            setIsOffline(false);
            setIsLoading(true);
            try {
                await axios.get(ENDPOINT_ACCOUNT_REFRESH_TOKEN);
                setIsOffline(false);
            } catch (error) {
                //console.log('ping error :>> ', error);
                if (error.code === 'ERR_NETWORK' || error?.response?.status === 401) {
                    setIsOffline(true);
                    retryInterval = setInterval(() => {
                        console.log('retryAfter :>> ', retryAfter);
                        setRetryAfter(prev => {
                            if (prev <= 0) {
                                clearInterval(retryInterval);
                                ping();
                                return RETRY_AFTER_SECONDS;
                            }
                            return prev - 1;
                        });

                    }, 1000);
                    // setTimeout(ping, 2000);
                }
            } finally {
                setIsLoading(false);
            }
        }
        ping();

        return () => {
            if (retryInterval) {
                clearInterval(retryInterval);
            }
        };
    }, []);

    return (
        <>
            <main className="d-flex flex-column vh-100">
                {
                    isLoading || isOffline ?
                        <div className="d-flex flex-column h-100 justify-content-center align-items-center">
                            <div className="card bg-light shadow-sm w-100" style={{ maxWidth: '30rem' }}>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    {isLoading &&
                                        <>
                                            <h5 className="card-title text-info m-0">Loading...</h5>
                                            <div className="spinner-border spinner-border-sm">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    }
                                    {isOffline &&
                                        <>
                                            <h5 className="card-title text-danger m-0">Service Unavailable</h5>
                                            <div className="small text-muted">
                                                <>retry after ({retryAfter} sec)</>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>

                        </div>
                        :
                        <>
                            <EventProvider>
                                <Header />
                                <Container fluid className="flex-grow-1 py-4">
                                    <Outlet />
                                </Container>
                            </EventProvider>
                        </>
                }
            </main>
        </>
    )
}

export default Layout
